import { size } from 'mol-ui';
import styled from 'styled-components';

export const Container = styled.div`
    align-items: center;
    border-right:1px #fff solid;
    cursor: pointer;
    display: none;
    justify-content: center;
    justify-self: flex-end;
    margin-right:10px;
    padding: 5px 10px 5px 0px;
    position: relative;
    transition: all 200ms ease;

    ${ size.md('display: flex') }

`;

export const Thumbnail = styled.div`
    position: relative;
    width: 30px;
    height: 30px;
    overflow: hidden;

    svg {
        width: 100%;
        vertical-align: text-top;
    }
`;

export const ThumbnailWrapper = styled.div`
    position: relative;
    width: 30px;
    height: 30px;
`;
